import type { BoxProps } from "@mui/material";
import { Box, Paper, ToggleButtonGroup } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const MainContainer = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  paddingRight: theme.spacing(1),
  height: "58px",
  minWidth: "100%",
  borderRadius: theme.spacing(0.5),
  position: "sticky",
  top: 10,
  zIndex: 1000,
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  height: "40px",
  gap: theme.spacing(0.5),
  "& .MuiToggleButton-root": {
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
    width: "163px",
    height: "42px",
    "&.Mui-selected": {
      border: "2px solid transparent",
      backgroundImage: `
        linear-gradient(${theme.palette.background.default}, ${theme.palette.background.default}),
        linear-gradient(132.08deg, ${theme.palette.primary.light} 40.23%, ${theme.palette.primary.main} 85.78%)
      `,
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
      boxShadow: `0px 1px 2px 1px ${alpha(theme.palette.primary.dark, 0.11)}, 0px 0px 1px -2px ${theme.palette.primary.light}`,
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
    },
  },
}));

export const LogoContainer = styled(Box)<BoxProps<"a">>(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));
